import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Assessment as AssessmentIcon } from "@mui/icons-material";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { newDate } from "helpers/dateTools";
import { dateValidator } from "helpers/dateValidator";
import { MAX_DATE_RANGE_DAYS } from "helpers/dictionary";
import { useSearch } from "hooks/useSearch";
import {
  setReportAuditSettlementsFilters,
  getReportAuditSettlementsAction,
} from "redux/actions/Reports/reportAuditSettlements/reportAuditSettlementsActions";
import { AUDIT_SETTLEMENTS_REPORT_LOADINGS } from "redux/reducers/Reports/reportAuditSettlements/types";

export const ReportAuditSettlementsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
  const { startDate, endDate, station } = useSelector((state) => state.reportAuditSettlements);

  const loading = isLoadingComp?.[AUDIT_SETTLEMENTS_REPORT_LOADINGS.GET_REPORT] ?? false;

  const handleSubmit = (isPdf) => {
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, MAX_DATE_RANGE_DAYS, setSnackbar)) return;
    dispatch(getReportAuditSettlementsAction({ startDate, endDate, station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte Liquidaciones Auditoría" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportAuditSettlements"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportAuditSettlementsFilters}
        submitAction={() => handleSubmit(true)}
        submitButtonName="PDF"
        submitSecond={() => handleSubmit(false)}
        loading={loading}
      />
    </GlobalBox>
  );
};
